import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const PDCAHubPage = lazy(() =>
  import('../pages/pdca/HubPage').then((m) => ({ default: m.HubPage }))
)
const PDCACyclesPage = lazy(() =>
  import('../pages/pdca/CyclesPage').then((m) => ({ default: m.CyclesPage }))
)
const PDCAImprovementPage = lazy(() =>
  import('../pages/pdca/ImprovementPage').then((m) => ({ default: m.ImprovementPage }))
)
const PDCAManagementReviewPage = lazy(() =>
  import('../pages/pdca/ManagementReviewPage').then((m) => ({ default: m.ManagementReviewPage }))
)

export const pdcaRoutes: RouteObject[] = [
  {
    path: 'pdca',
    children: [
      { index: true, element: <PDCAHubPage /> },
      { path: 'hub', element: <PDCAHubPage /> },
      { path: 'cycles', element: <PDCACyclesPage /> },
      { path: 'improvement', element: <PDCAImprovementPage /> },
      { path: 'management-review', element: <PDCAManagementReviewPage /> },
    ],
  },
]
